import { FC } from 'react'
import styles from 'components/features/pfm/PostComposeError/PostComposeError.styl'
import cn from 'classnames'

type PostComposeErrorProps = {
  direction?: 'toLeft' | 'toTop',
  isShown: boolean
}

export const PostComposeError: FC<PostComposeErrorProps> = ({
  direction,
  isShown,
  children,
}) => {
  const className = cn(
    styles.postComposeError,
    {
      [styles.toTop]: direction === 'toTop',
      [styles.toLeft]: direction === 'toLeft',
      [styles.shown]: isShown,
    }
  )
  return (
    <div className={ className }>
      <div className={ styles.caret } />
      <div className={ styles.text }>
        { children }
      </div>
    </div>
  )
}
